module.exports = __webpack_public_path__ + "img/main-content-default.fe3fa0fe.svg";